import { Suspense, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';

import './App.css';
import { AppDispatch } from './app/store';
import { finishAuthCheck, getAuthUser } from './features/auth/authSlice';
import RouteNotAuth from './utils/authRoutes/RouteNotAuth';
import PrivateRoute from './utils/authRoutes/PrivateRoute';
import PageHome from './views/PageHome';
import AdminPage from './views/AdminPage';
import Loading from './components/loading/Loading';
import PageCart from './views/PageCart';
import FooterPage from './components/footers/FooterPage';
import Impressum from './components/impressum/Impressum';
import PageSignIn from './views/PageSignIn';
import PageSignUp from './views/PageSignUp';

function App(): JSX.Element {
	const { i18n } = useTranslation();
	const dispatch = useDispatch<AppDispatch>();

	useEffect(() => {
		const languageFromCookies = Cookies.get('selectedLanguage');

		if (languageFromCookies && languageFromCookies !== i18n.language) {
			i18n.changeLanguage(languageFromCookies);
		}
	}, [i18n]);

	useEffect(() => {
		if (Cookies.get('refreshToken')) {
			dispatch(getAuthUser());
		} else {
			dispatch(finishAuthCheck());
		}
	}, [dispatch]);

	return (
		<div className="app">
			<div className="mainContent">
				<Suspense fallback={<Loading />}>
					<Routes>
						<Route element={<RouteNotAuth />}>
							<Route path="/SignIn" element={<PageSignIn />} />
							<Route path="/SignUp" element={<PageSignUp />} />
						</Route>

						<Route element={<PrivateRoute />}>
							<Route path="/admin" element={<AdminPage />} />
						</Route>

						<Route path="/" element={<PageHome />} />
						<Route path="/menu/:category" element={<PageHome />} />
						<Route path="/cart" element={<PageCart />} />
						<Route path="/impressum" element={<Impressum />} />
					</Routes>
				</Suspense>
			</div>

			<FooterPage />
		</div>
	);
}

export default App;
